/**
 * Register environment variable names here for strict type checking
 */
export type EnvironmentVariables =
  | "REACT_APP_*"
  | "REACT_APP_API_HOST"
  | "REACT_APP_DOCKER_IMAGE_TAG"
  | "REACT_APP_GA_KEY"
  | "REACT_APP_GA4_KEY"
  | "REACT_APP_ROUTE_PREFIX"
  | "REACT_APP_V1_ROUTE_PREFIX"
  | "REACT_APP_ENVIRONMENT"
  | "REACT_APP_HOST"
  | "REACT_APP_V1_HOST"
  | "REACT_APP_OPTIN_HOST"
  | "REACT_APP_GOID_CLIENT_ID"
  | "REACT_APP_GOBIZ_API_HOST"
  | "REACT_APP_ENABLE_REFRESH_TOKEN_INJECTION"
  | "REACT_APP_DISABLE_ASYNC_DELAY"
  | "REACT_APP_HERMES_RESET_PASSWORD_LINK"
  | "REACT_APP_HERMES_RESEND_CONFIRMATION_LINK"
  | "REACT_APP_HERMES_CLIENT_ID"
  | "REACT_APP_POS_OPTIN_CLEVERTAP_ID"
  | "REACT_APP_HERA_HOST"
  | "REACT_APP_OPD_HOST"
  | "REACT_APP_HERMES_HOST"
  | "REACT_APP_GROCERIES_HOST"
  | "REACT_APP_IMAGE_COMPRESSION_QUALITY_RATE"
  | "REACT_APP_IMAGE_TO_COMPRESS_MIN_SIZE"
  | "REACT_APP_TNC_HOST"
  | "REACT_APP_HERA_COOKIE"
  | "REACT_APP_MARS_HOST"
  | "REACT_APP_BUSINESS_ENTITY_VALIDATION_TIMESTAMP"
  | "REACT_APP_NEWRELIC_DENY_LIST"
  | "REACT_APP_NEWRELIC_BEACON"
  | "REACT_APP_NEWRELIC_LICENSE_KEY"
  | "REACT_APP_NEWRELIC_APPLICATION_ID"
  | "REACT_APP_NEWRELIC_ACCOUNT_ID"
  | "REACT_APP_NEWRELIC_TRUST_KEY"
  | "REACT_APP_MOENGAGE_ENABLED";
/**
 * In development, will attempt to retrieve environment variables from `process.env`, while on production, will return
 * value from server injected variable `$_ENV`.
 * @param variableName
 */
export const fromEnv = <T = any>(variableName: EnvironmentVariables): T => {
  const variable =
    process.env.NODE_ENV === "development" || process.env.NODE_ENV === "test"
      ? process.env[variableName]
      : $_ENV[variableName];

  if (typeof variable === "undefined") {
    // Cannot use Logger.warn here since it would create a cyclic dependency
    console.warn(`Missing env variable ${variableName}`);
  }

  return variable as any;
};
